import React from "react";
import { Navigate, useLocation } from "react-router-dom";

// /signin is a legacy alias for /login. Redirect instead of mounting Login twice so
// there is one canonical auth URL; the query string carries ?next= through.
const SigninAliasRedirect = () => {
  const location = useLocation();
  return <Navigate to={{ pathname: "/login", search: location.search }} replace />;
};

export default SigninAliasRedirect;
